// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__7UtbR","itemImage":"styles_itemImage__AmDJM"};